import { Component, OnInit } from '@angular/core';
import { PortalInfo } from '../../models/instance-types';
import { AppConfigService } from '../../services/app-config.service';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.css'],
  standalone: false
})
export class LandingComponent implements OnInit {
  portalInfo: PortalInfo[] = [];

  constructor(
    private auth: AuthService,
    private appConfigService: AppConfigService
  ) {}

  ngOnInit(): void {
    var config = this.appConfigService.getConfig();
    var allPortals = config.ExternalPortalInfo as PortalInfo[];

    for (var info of allPortals) {
      if (this.auth.isInAnyRole(info.Roles)) {
        this.portalInfo.push(info);
      }
    }
  }
}
